<template>
  <div
    class="col-md-12 card_flex"
    style="height: 100%"
  >
    <div class="header">
      <div class="form">
        <fg-input
            v-model="searched_user"
            type="text"
            class="search_user"
            placeholder="Name, login, email or phone"
            :label="this.translate('user.search_user')"
        />

        <div class="select">
          <label> {{ translate('user.users_state') }} </label>
          <sis-select
              :options="user_states"
              :multiple="false"
              v-model="state"
              :placeholder="translate('device.group.many')"
              :clearable="false"
          />
        </div>
      </div>

      <span
        class="mdi mdi-plus-circle-outline btn btn-success btn-fill"
        @click.prevent="new_user({})"
      >
        <b>{{ translate('user.to_add') }}</b>
      </span>
    </div>

    <div class="response_table card_table">
      <table>
        <thead style="flex:0;">
          <tr>
            <th scope="col" style="width: 40px">
              ID
            </th>
            <th scope="col">
              {{ translate('user.name') }}
            </th>
            <th scope="col">
              {{ translate('user.login') }}
            </th>
            <th scope="col">
              email
            </th>
            <th scope="col">
              {{ translate('user.client') }}
            </th>
            <th scope="col">
              {{ translate('device.group.many') }}
            </th>
            <th scope="col">
              {{ translate('user.last_try_ts') }}
            </th>
            <th scope="col" style="width: 10px"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-if="load"
            style="border:none; background-color:  transparent;"
          >
            <td> <scale-loader /> </td>
          </tr>
          <tr
            v-for="(user,key) in users_list"
            :key="key"
            @click="new_user(user)"
            class="user"
          >
            <td data-label="ID" style="width: 40px">
              {{ user.id }}
            </td>
            <td :data-label="translate('user.name')">
              {{ user.name }}
            </td>
            <td :data-label="translate('user.login')">
              {{ user.username }}
            </td>
            <td data-label="email">
              {{ user.email }}
            </td>
            <td :data-label="translate('user.client')">
              {{ user_client(user.client_id) }}
            </td>
            <td :data-label="translate('user.groups')" class="user_groups">
              <span
                v-for="(group, group_key) in user_groups(user.group)"
                :key="group_key"
                class="user_groups__item"
              >
                {{group}}
              </span>
            </td>
            <td :data-label="translate('user.last_try_ts')">
              {{ get_date(user.last_try_ts) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>


import EditProfile from './UserProfile/EditUserProfile'


export default {
  name: 'UserList',
  props: ['role_list','permission_list'],
  components: {
  },
  data () {
    return {
      load: true,
      users: [],
      init: false,
      searched_user: '',
      state: 'all',
      client_ids: [],
      check_link: true
    }
  },

  updated: function () {
    this.$nextTick(function () {
      this.init = true
    })
  },

  activated () {
    this.getUsers()
  },
  mounted () {
    this.getUsers()
  },

  computed:{
    user_states(){
      return [
        {'label':'all', 'id': 'all'},
        {'label':'active', 'id': 'active'},
        {'label':'blocked', 'id': 'blocked'}
      ]
    },
    users_list() {
      let list_actived = []
      let list_searched = []

      for (let user in this.users) {
        if (this.searched_user !== ''){
          if (this.users[user].name.toLowerCase().indexOf(this.searched_user.toLowerCase()) > -1 || //Проверка имени в нижнем регистре
              this.users[user].username.toLowerCase().indexOf(this.searched_user.toLowerCase()) > -1 || //Проверка логина в нижнем регистре
              this.users[user].email.toLowerCase().indexOf(this.searched_user.toLowerCase()) > -1 ||  //Проверка почты в нижнем регистре
              this.users[user].phone.toLowerCase().indexOf(this.searched_user.toLowerCase()) > -1 //Проверка Телефона в нижнем регистре
          ) {
            list_searched.push(this.users[user])
          }
        }

        switch (this.state) {
          case "active":{
            if (this.users[user].active === 1) {
              list_actived.push(this.users[user])
            }
            break
          }
          case "blocked":{
            if (this.users[user].active === 0) {
              list_actived.push(this.users[user])
            }
            break
          }
          case "all":{
            list_actived.push(this.users[user])
          }
        }
      }
      if (this.searched_user === ''){
        return list_actived
      }else{
        let final_list = list_actived.filter(x => list_searched.includes(x));
        final_list = [...new Set(final_list)]
        return final_list
      }
    }
  },

  methods: {
    close_modal () {
      if (!this.check) {
         history.pushState(null, null, this.window_info)
      }else{
        window.location.href = window.location.href.replace('/' + this.$route.params.user_id, '')
      }
    },
    check_user(){
      if (this.$route.params.user_id){
        for (let index in this.users) {
          if ('@' + this.users[index].username === this.$route.params.user_id) {
            this.show_profile(this.users[index], true)
          }
        }
      }
    },
    show_profile(val){
      if (this.$route.params.usermanagment_section === 'users') {
        if (this.check_link){
          this.check_link = false
          this.new_user(val)
        }
      }
    },
    user_client(client_id){
      return this.client_ids[client_id]
    },

    user_groups(groups_id){
      let all_groups = this.$store.getters.getDeviceGroups
      let users_group = []
      if (groups_id) {
        for (let group_id of groups_id) {
          for (let group of all_groups) {
            if (group.id === group_id) users_group.push(group.name)
          }
        }
      }
      return users_group
    },

    new_user (val) {
      if (Object.keys(val).length === 0) {
        val = {
          active: 1,
          email: '',
          client_id: null,
          name: '',
          phone: '',
          username: ""
        }
      }
      var t = this.$createElement(EditProfile, {
        props: {
          user: val,
          client_ids: this.client_ids,
          role_list: this.role_list,
          permission_list: this.permission_list
        },
        on: {
          close: () => {
            this.$modal.hide('user_profile_modal')
            this.check_link = true
          },
          update: () => { this.getUsers() }
        }
      })
      let temp = {render () { return t }}
      this.$modal.show(temp, {}, {
        height: 800,
        width: 800,
        adaptive: true,
        clickToClose: true,
        name: 'user_profile_modal'
      })
    },

    getUsers () {
      this.$http.v1.getUsersList((response) => {
          this.load = false
          this.init = false
          this.users = response.data.users
          this.client_ids = response.data.clients
          this.check_user()
      })
    },
  }
}

</script>

<style lang="scss" scoped>
  .header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 50%;
      .search_user{
        margin-bottom: 0;
        width: 50%;
      }
      .select{
        width: 50%;
        margin: 0 10px;
        .form-group {
          margin-bottom: 0;
        }
      }
    }
    .btn{
      width: 30%;
      height: 40px;
    }
  }
  .response_table{
    padding: 10px 0;
  }
  .card_table{
    table{
      tbody{
        &::-webkit-scrollbar {
          width: 10px;
        }
      }
    }
  }

  .user{
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }

    &_groups{
      min-height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;

      &__item {
        background: #fff;
        border: 1px solid #ddd;
        padding: 1px 4px;
        border-radius: 5px;
        margin: 0 3px 3px 0;
      }
    }
    .roles{
      font-size: 20px;
    }
  }

  @media (max-width: 1366px) {
    .response_table{
      font-size: 13px;
    }
  }

  @media (max-width: 768px){
    .header{
      .btn{
        width: 35%;
        min-width: 240px;
      }
      .search_user{
        width: 65%;
        margin-right: 10px;
      }
    }
  }

  @media (max-width: 750px){
    .user{
      &_groups{
        justify-content: space-between;
      }
    }
  }

  @media (max-width: 500px){
    .header{
      .form{
        width: 100%;
        .filter{
          min-width: max-content;
          margin: 0 10px;
        }
      }
      .btn{
        b{
          display: none;
        }
        width: 20%;
        min-width: inherit;
      }
      .search_user{
        width: 80%;
      }
    }
  }



</style>
